/**
 * Account type constants
 */
export const ACCOUNT_TYPES = {
  BANK: "BANK",
  CASH: "CASH",
} as const;

export const CASH_BANK_OPTION_NAME = "Caixa do Terreiro (Dinheiro Físico)";

export type AccountType = (typeof ACCOUNT_TYPES)[keyof typeof ACCOUNT_TYPES];

/**
 * Check if an account is a bank account (not cash)
 */
export function isBankAccount(accountType: string | undefined): boolean {
  return accountType === ACCOUNT_TYPES.BANK;
}

/**
 * Check if an account is a cash account
 */
export function isCashAccount(accountType: string | undefined): boolean {
  return accountType === ACCOUNT_TYPES.CASH;
}
